import React from 'react';

export default function CarCard({ car, onBook }) {
  return (
    <div className="car-card">
      <div className="car-card-img-wrap">
        {car.image
          ? <img className="car-card-img" src={car.image} alt={car.name} />
          : <div className="car-card-img" style={{ display:'flex', alignItems:'center', justifyContent:'center', background:'#F3F4F6', fontSize:48 }}>🚗</div>
        }
        <div className="car-card-badge">
          {car.available
            ? <span className="badge badge-green">Available</span>
            : <span className="badge badge-gray">Unavailable</span>}
        </div>
        {!car.available && <div className="car-card-unavailable">Currently Rented</div>}
      </div>
      <div className="car-card-body">
        <div className="car-card-top">
          <div>
            <div className="car-card-name">{car.name}</div>
            <div className="car-card-category">{car.year} · {car.category}</div>
          </div>
          <div>
            <div className="car-card-price">€{car.price}</div>
            <div className="car-card-price-label">per day</div>
          </div>
        </div>
        <div className="car-card-specs">
          <div className="spec-item"><span className="spec-label">Seats</span><span className="spec-value">{car.seats}</span></div>
          <div className="spec-item"><span className="spec-label">Trans.</span><span className="spec-value">{car.transmission}</span></div>
          <div className="spec-item"><span className="spec-label">Fuel</span><span className="spec-value">{car.fuel}</span></div>
          <div className="spec-item"><span className="spec-label">KM</span><span className="spec-value">{car.mileage}</span></div>
        </div>
      </div>
      <div className="car-card-action">
        <button
          className="btn-primary"
          disabled={!car.available}
          style={!car.available ? { opacity:0.4, cursor:'not-allowed' } : {}}
          onClick={() => car.available && onBook(car)}
        >
          {car.available ? 'Book Now' : 'Unavailable'}
        </button>
      </div>
    </div>
  );
}